<div class="title">
  <p>{{ "COMMON.MBC_DETAILS.SUB_FEEDER" | translate }}</p>
  <div class="button-group">
    <button
      type="button"
      class="btn btn-primary"
      data-bs-toggle="modal"
      data-bs-target="#addNewF11"
      (click)="addNew()"
      *ngIf="
        permissionsService.isF11CreateEditAllowed &&
        utilityId != 0 &&
        bpsAdminLevel != 2
      "
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8 0C7.4477 0 7 0.44772 7 1V7H1C0.44772 7 0 7.4477 0 8C0 8.5523 0.44772 9 1 9H7V15C7 15.5523 7.4477 16 8 16C8.5523 16 9 15.5523 9 15V9H15C15.5523 9 16 8.5523 16 8C16 7.4477 15.5523 7 15 7H9V1C9 0.44772 8.5523 0 8 0Z"
          fill="white"
        />
      </svg>
      {{ "CRUD_SETTINGS.ADD_NEW" | translate }}
    </button>
    <button
        type="button"
        class="btn btn-secondary"
        (click)="download()"
        *ngIf="permissionsService.isF11CreateEditAllowed && bpsAdminLevel != 2"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8 10.5L11.5 7L10.25 5.75L9 7V3H7V7L5.75 5.75L4.5 7L8 10.5ZM2 14H14V12H2V14Z"
            fill="white"
          />
        </svg>
        {{ "CRUD_SETTINGS.DOWNLOAD" | translate }}
    </button>
  </div>
</div>
<div class="container-fluid border-bottom">
  <table>
    <tr class="header-row">
      <th>{{ "COMMON.MBC_DETAILS.FEEDER_NAME" | translate }}</th>
      <th>{{ "COMMON.MBC_DETAILS.FEEDER_NUMBER" | translate }}</th>
      <th>{{ "COMMON.SS.SINGLE" | translate }}</th>
      <th>{{ "COMMON.MBC_DETAILS.MAIN_FEEDER" | translate }}</th>
      <th>{{ "COMMON.TS.SINGLE" | translate }}</th>
      <th>{{ "COMMON.BU.SINGLE" | translate }}</th>
      <th>{{ "CRUD_SETTINGS.SUB_FEEDER_NAMEPLATE_RATING" | translate }}</th>
      <th>Code</th>
      <th *ngIf="permissionsService.hasDashboardConfigFeederBands">Band</th>

      <th></th>
    </tr>
    <tr
      class="content-wrapper"
      *ngFor="let f11 of feeders11"
      data-bs-toggle="modal"
      data-bs-target="#addNewF11"
      (click)="
        permissionsService.isF11CreateEditAllowed ? selectF11(f11) : null
      "
    >
      <td>{{ f11.name | hasValue }}</td>
      <td>{{ f11.number | hasValue }}</td>
      <td>{{ f11.substation?.name | hasValue }}</td>
      <td>{{ f11.feeder33?.name | hasValue }}</td>
      <td>{{ f11.transmissionStation?.name | hasValue }}</td>
      <td>{{ f11.region?.name | hasValue }}</td>
      <td>{{ f11.nameplateRating | hasValue }}</td>
      <td>{{ f11.code | hasValue }}</td>
      <td *ngIf="permissionsService.hasDashboardConfigFeederBands">{{ f11.feederBand | hasValue }}</td>
      <td class="td-svg">
        <svg
          data-bs-toggle="modal"
          data-bs-target="#deleteF11"
          (click)="selectF11(f11)"
          width="22"
          height="22"
          viewBox="0 0 22 22"
          xmlns="http://www.w3.org/2000/svg"
          *ngIf="permissionsService.isF11DeleteAllowed && bpsAdminLevel != 2"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20ZM6 11C6 10.4477 6.44772 10 7 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H7C6.44772 12 6 11.5523 6 11Z"
            fill="#DE350B"
          />
        </svg>
      </td>
    </tr>
  </table>
</div>
<div>
  <app-paging
    *ngIf="count > 0"
    [pageSize]="pageSize"
    [count]="count"
    [currentPage]="currentPage"
    (pageChange)="pageChange($event)"
  ></app-paging>
</div>

<div
  class="modal fade"
  id="addNewF11"
  tabindex="-1"
  aria-hidden="true"
  *ngIf="permissionsService.isF11CreateEditAllowed"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          {{ actionLabel$ | async }} {{ "COMMON.MBC_DETAILS.SUB_FEEDER" | translate }}
        </h5>
        <button
          type="button"
          #closeAddModal
          class="btn-cancel-modal"
          data-bs-dismiss="modal"
        >
          {{ "COMMON.CANCEL" | translate }}
        </button>
      </div>
      <form
        id="addForm"
        class="form-wrapper"
        ngNativeValidate
        (submit)="save()"
      >
        <div class="modal-body">
          <div class="form-item form-floating mb-3">
            <input
              id="feederName"
              name="name"
              type="text"
              [(ngModel)]="selectedF11.name"
              class="form-control"
              required
              placeholder=" "
            />
            <label for="feederName">{{
              "COMMON.MBC_DETAILS.FEEDER_NAME" | translate
            }}</label>
          </div>
          <div class="form-item form-floating mb-3">
            <input
              id="feederNumber"
              name="number"
              type="text"
              [(ngModel)]="selectedF11.number"
              class="form-control"
              required
              placeholder=" "
            />
            <label for="feederNumber">{{
              "COMMON.MBC_DETAILS.FEEDER_NUMBER" | translate
            }}</label>
          </div>

          <div class="form-item form-floating mb-3">
            <select
              [ngClass]="isDirectToTs !== null ? 'selected-option' : ''"
              name="isDirectToTs"
              [(ngModel)]="isDirectToTs"
              (ngModelChange)="onDirectToTsChange()"
              required
              class="form-select"
            >
              <option [ngValue]="null" disabled>
                {{ 'COMMON.IS_DIRECT_TO_TS' | translate }}
              </option>
              <option [ngValue]="true">
                {{'COMMON.YES' | translate}}
              </option>
              <option [ngValue]="false">
                {{'COMMON.NO' | translate}}
              </option>
            </select>

            <label
              *ngIf="isDirectToTs != null"
              class="label-for-select"
              for="floatingSelect"
              >{{ 'COMMON.IS_DIRECT_TO_TS' | translate }}</label
            >

            <div *ngIf="isDirectToTs == null" class="select-title"></div>
          </div>

          <div *ngIf="isDirectToTs == true" class="form-item form-floating mb-3">
            <select
              [ngClass]="selectedTsId !== undefined ? 'selected-option' : ''"
              name="selectTs"
              (change)="selectTs($event)"
              required
              class="form-select"
            >
              <option value="" [selected]="selectedTsId === undefined" disabled>
                {{ "COMMON.TS.SINGLE" | translate }}
              </option>
              <option
                *ngFor="let ts of tss"
                [selected]="selectedTsId === ts.id"
                value="{{ ts.id }}"
              >
                {{ ts.name }}
              </option>
            </select>
            <label
              *ngIf="selectedTsId !== undefined"
              class="label-for-select"
              for="floatingSelect"
              >{{ "COMMON.TS.SINGLE" | translate }}</label
            >
            <div *ngIf="selectedTsId !== undefined" class="select-title"></div>
          </div>

          <div *ngIf="isDirectToTs == false" class="form-item form-floating mb-3">
            <app-dropdown-search
              [items]="substations"
              id="substation-dropdown"
              label="COMMON.SS.SINGLE"
              [selectedItemId]="selectedSsId ?? null"
              (selectedIdChange)="selectSs($event)"
            >
            </app-dropdown-search>
           
          </div>
          <div *ngIf="isDirectToTs == false" class="form-item form-floating mb-3">
            <app-dropdown-search *ngIf="f33s.length > 0"
              [items]="f33s"
              id="substation-dropdown"
              label="COMMON.MBC_DETAILS.MAIN_FEEDER"
              [selectedItemId]="selectedF33Id ?? null"
              (selectedIdChange)="selectF33($event)"
            >
            </app-dropdown-search>
          </div>
          <div class="form-item form-floating mb-3">
            <app-dropdown-search
              [items]="convertedRegions"
              id="substation-dropdown"
              label="COMMON.BU.SINGLE"
              [selectedItemId]="selectedRegionId"
              (selectedIdChange)="selectRegion($event)"
            >
            </app-dropdown-search>
          </div>
          <div class="form-item form-floating mb-3">
            <select
              [ngClass]="selectedF11.nameplateRating ? 'selected-option' : ''"
              name="nameplateRating"
              (change)="selectNameplateRating($event)"
              required
              class="form-select"
            >
              <option
                value=""
                [selected]="!selectedF11.nameplateRating"
                disabled
              >
                {{ "CRUD_SETTINGS.SUB_FEEDER_NAMEPLATE_RATING" | translate }}
              </option>
              <option
                *ngFor="let nameplate of nameplateRatingOptions"
                [selected]="selectedF11.nameplateRating === nameplate"
                value="{{ nameplate }}"
              >
                {{ nameplate }}
              </option>
            </select>
            <label
              *ngIf="selectedF11.nameplateRating"
              class="label-for-select"
              for="floatingSelect"
              >{{
                "CRUD_SETTINGS.SUB_FEEDER_NAMEPLATE_RATING" | translate
              }}</label
            >
            <div *ngIf="selectedF11.nameplateRating" class="select-title"></div>
          </div>
          <div *ngIf="permissionsService.hasDashboardConfigFeederBands" class="form-item form-floating mb-3">
            <input
              id="feederBand"
              name="feederBand"
              type="text"
              [(ngModel)]="selectedF11.feederBand"
              class="form-control"
              disabled
              placeholder=" "
            />
            <label for="feederBand">Band</label>
          </div>
        </div>
        <div class="modal-footer" *ngIf="bpsAdminLevel != 2">
          <button class="btn btn-primary" form="addForm">
            {{ "COMMON.SAVE" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="deleteF11" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header delete-modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          {{ "CRUD_SETTINGS.ARE_YOU_SURE_DELETE" | translate }}
          {{ "COMMON.FEEDER" | translate }}?
        </h5>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="deleteF11()">
          {{ "COMMON.DELETE" | translate }}
        </button>
        <button
          #closeDeleteModal
          hidden="true"
          data-bs-dismiss="modal"
        ></button>
      </div>
    </div>
  </div>
</div>
